import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { handleLocalStorage } from '../handleLocalStorage';

import de from './de/main.json';
import en from './en/main.json';
import fr from './fr/main.json';
import it from './it/main.json';

const SUPPORTED_LANGS = ['de', 'fr', 'it', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGS)[number];

function getInitialLanguage(): SupportedLanguage {
  let userLang = handleLocalStorage('lang');
  if (!userLang) {
    userLang = typeof navigator !== 'undefined' ? navigator.language?.slice(0, 2) : undefined;
  }
  const found = SUPPORTED_LANGS.find((l) => l === userLang);
  return found ?? 'de';
}

const resources = {
  en: { translation: en },
  de: { translation: de },
  fr: { translation: fr },
  it: { translation: it },
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: 'de',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
